import { FormGroup, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Switch as SwitchBut } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useState, useRef } from "react";
import { Button, Card, Spinner, Table, Form } from "react-bootstrap";
import {
    useParams
} from "react-router-dom";
import { db } from '../../../firebase';
import EditRubber from './editRubber';
import Rubber from "./rubber";

/*
    Contain all results between two teams ie. multiple rubbers 
    No more navbars and routes. Display everything in one screen
*/
export default function Match(props) {
    let { id } = useParams()

    let [loading, setLoading] = useState(true)
    let [onDel, setOnDel] = useState(false)
    let [onAdd, setonAdd] = useState(false)
    let [onEditScore, setonEditScore] = useState(false)
    let [availablePlys, setavailablePlys] = useState([])
    let [playerPool, setplayerPool] = useState([])
    let [chooseFromAllPlys, setchooseFromAllPlys] = useState('false')
    let [onEditMatch, setonEditMatch] = useState(false)

    let [matchName, setmatchName] = useState(null)
    let [matchTime, setmatchTime] = useState(null)

    // add thisplayers
    let [isMode2, setisMode2] = useState(false)
    let [t1p1, sett1p1] = useState(null) // team 1 player 1
    let [t1p2, sett1p2] = useState(null)
    let [t1p3, sett1p3] = useState(null)
    let [t2p1, sett2p1] = useState(null) // team 2 player 1
    let [t2p2, sett2p2] = useState(null)
    let [t2p3, sett2p3] = useState(null)
    let inputPlayerRefs = {
        "t1p1": { name: "Team 1 player 1", value: t1p1, setFunc: sett1p1 },
        "t1p2": { name: "Team 1 player 2", value: t1p2, setFunc: sett1p2 },
        "t1p3": { name: "Team 1 player 3", value: t1p3, setFunc: sett1p3 },
        "t2p1": { name: "Team 2 player 1", value: t2p1, setFunc: sett2p1 },
        "t2p2": { name: "Team 2 player 2", value: t2p2, setFunc: sett2p2 },
        "t2p3": { name: "Team 2 player 3", value: t2p3, setFunc: sett2p3 },
    }
    let inputPlayerRefsMode2 = {
        "t1p1": { name: "Team 1 player 1", value: t1p1, setFunc: sett1p1 },
        "t1p2": { name: "Team 1 player 2", value: t1p2, setFunc: sett1p2 },
        "t2p1": { name: "Team 2 player 1", value: t2p1, setFunc: sett2p1 },
        "t2p2": { name: "Team 2 player 2", value: t2p2, setFunc: sett2p2 },
    }
    let [thisPlayers, setthisPlayers] = useState({})
    let [rubbers, setrubbers] = useState([])
    let [rubberResults, setrubberResults] = useState({})
    let [editRubbers, seteditRubbers] = useState([])

    let [r1s1, setr1s1] = useState(null)
    let [r2s1, setr2s1] = useState(null)
    let [r3s1, setr3s1] = useState(null)
    let [r4s1, setr4s1] = useState(null)
    let [r5s1, setr5s1] = useState(null)
    let [r6s1, setr6s1] = useState(null)

    let [r1s2, setr1s2] = useState(null)
    let [r2s2, setr2s2] = useState(null)
    let [r3s2, setr3s2] = useState(null)
    let [r4s2, setr4s2] = useState(null)
    let [r5s2, setr5s2] = useState(null)
    let [r6s2, setr6s2] = useState(null)

    let matchRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(props.dayID).collection("matches").doc(id)

    let availabilityDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(props.dayID)
        .collection("availability")

    // delete this day
    function handleDelete() {
        setOnDel(true)
    }

    function handleCancel() {
        setOnDel(false)
    }

    function handleConfDel() {
        matchRef.delete()
            .then(() => {
                console.log("season document deleted!!!")
                props.reloadMatches()
                setOnDel(false)
            }).catch((e) => {
                console.log(e)
            })
    }

    // modify match
    function handleConfEditMatch() {

    }


    // modify players in this match
    function handleAddthisPlayers() {
        setonAdd(true)
    }

    function handleCancelAddPlayers() {
        setonAdd(false)
    }

    function handleConfAddPlayers() {
        setLoading(true)
        let toUpLoadPlys = isMode2 ?
            {
                "t1p1": t1p1 ? t1p1 : null,
                "t1p2": t1p2 ? t1p2 : null,
                "t2p1": t2p1 ? t2p1 : null,
                "t2p2": t2p2 ? t2p2 : null,
            }
            :
            {
                "t1p1": t1p1 ? t1p1 : null,
                "t1p2": t1p2 ? t1p2 : null,
                "t1p3": t1p3 ? t1p3 : null,
                "t2p1": t2p1 ? t2p1 : null,
                "t2p2": t2p2 ? t2p2 : null,
                "t2p3": t2p3 ? t2p3 : null,
            }
        console.log(toUpLoadPlys)

        matchRef.update({
            thisPlayers: toUpLoadPlys,
            isMode2: isMode2
        })
            .then(() => {
                console.log(`Document updated!!!`)
                getthisPlayers()
                setonAdd(false)
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setonAdd(false)
                setLoading(false)
            })
    }

    // return all players in this match
    function getthisPlayers() {
        setLoading(true)
        matchRef.get()
            .then((doc) => {
                if (doc.data().thisPlayers) {
                    let resthisPlayers = doc.data().thisPlayers
                    let toDspPlys = {
                        "t1p1": resthisPlayers["t1p1"],
                        "t1p2": resthisPlayers["t1p2"],
                        "t1p3": resthisPlayers["t1p3"],
                        "t2p1": resthisPlayers["t2p1"],
                        "t2p2": resthisPlayers["t2p2"],
                        "t2p3": resthisPlayers["t2p3"],
                    }
                    setthisPlayers(toDspPlys)
                } else {
                    setthisPlayers({})
                }
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    // onLoad
    function updatePlyRefs() {
        sett1p1(thisPlayers["t1p1"])
        sett1p2(thisPlayers["t1p2"])
        sett1p3(thisPlayers["t1p3"])
        sett2p1(thisPlayers["t2p1"])
        sett2p2(thisPlayers["t2p2"])
        sett2p3(thisPlayers["t2p3"])
    }

    // player pool 
    function getPlayerPool() {
        db.collection("appusers").get()
            .then((querySnapShot) => {
                var newplayerPool = []
                querySnapShot.forEach((doc) => {
                    let data = doc.data()
                    var player = {
                        displayName: data.displayName,
                        uid: data.uid,
                        id: doc.id,
                    }
                    newplayerPool.push({ player })
                })
                setplayerPool(newplayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function getavailablePlys() {
        availabilityDBRef.get()
            .then((querySnapShot) => {
                var newplayerPool = []
                querySnapShot.forEach((doc) => {
                    let data = doc.data()
                    var player = {
                        displayName: data.displayName,
                        uid: data.uid,
                        id: doc.id,
                    }
                    newplayerPool.push({ player })
                })
                setavailablePlys(newplayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function getRubResults() {
        setLoading(true)
        matchRef.get()
            .then((doc) => {
                if (doc.data().isMode2) {
                    setisMode2(true)
                    if (doc.data().results) {
                        let resRst = doc.data().results
                        let toDspRst = {
                            "r1s1": resRst["r1s1"],
                            "r1s2": resRst["r1s2"],
                            "r2s1": resRst["r2s1"],
                            "r2s2": resRst["r2s2"],
                            "r3s1": resRst["r3s1"],
                            "r3s2": resRst["r3s2"],

                            "r4s1": resRst["r4s1"],
                            "r4s2": resRst["r4s2"],
                            "r5s1": resRst["r5s1"],
                            "r5s2": resRst["r5s2"],
                        }
                        setrubberResults(toDspRst)
                    } else {
                        setrubberResults({})
                    }
                }
                else {
                    setisMode2(false)
                    if (doc.data().results) {
                        let resRst = doc.data().results
                        let toDspRst = {
                            "r1s1": resRst["r1s1"],
                            "r1s2": resRst["r1s2"],
                            "r2s1": resRst["r2s1"],
                            "r2s2": resRst["r2s2"],
                            "r3s1": resRst["r3s1"],
                            "r3s2": resRst["r3s2"],

                            "r4s1": resRst["r4s1"],
                            "r4s2": resRst["r4s2"],
                            "r5s1": resRst["r5s1"],
                            "r5s2": resRst["r5s2"],
                            "r6s1": resRst["r6s1"],
                            "r6s2": resRst["r6s2"],
                        }
                        setrubberResults(toDspRst)
                    } else {
                        setrubberResults({})
                    }
                }
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    function handleConfSaveRst() {
        setLoading(true)
        let toDspRst = isMode2 ?
            {
                "r1s1": r1s1,
                "r1s2": r1s2,
                "r2s1": r2s1,
                "r2s2": r2s2,
                "r3s1": r3s1,
                "r3s2": r3s2,

                "r4s1": r4s1,
                "r4s2": r4s2,
                "r5s1": r5s1,
                "r5s2": r5s2,
            }
            :
            {
                "r1s1": r1s1,
                "r1s2": r1s2,
                "r2s1": r2s1,
                "r2s2": r2s2,
                "r3s1": r3s1,
                "r3s2": r3s2,

                "r4s1": r4s1,
                "r4s2": r4s2,
                "r5s1": r5s1,
                "r5s2": r5s2,
                "r6s1": r6s1,
                "r6s2": r6s2,
            }

        console.log(toDspRst)

        matchRef.update({
            results: toDspRst
        })
            .then(() => {
                console.log(`Document results updated!!!`)
                setonEditScore(false)
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setonEditScore(false)
                setLoading(false)
            })
    }

    // generate rubbers with the players added
    /*
        rubber1 : #1 single
        rubber2 : #2 single
        rubber3 : #3 single
        rubber4 : #1#2 double
        rubber5 : #1#3 double
        rubber6 : #2#3 double
    */
    function genRubbers() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], rubberResults["r1s1"], rubberResults["r1s2"]],
            ["rubber2", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], rubberResults["r2s1"], rubberResults["r2s2"]],
            ["rubber3", [thisPlayers["t1p3"]], [thisPlayers["t2p3"]], rubberResults["r3s1"], rubberResults["r3s2"]],

            ["rubber4", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], rubberResults["r4s1"], rubberResults["r4s2"]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p3"]], [thisPlayers["t2p1"], thisPlayers["t2p3"]], rubberResults["r5s1"], rubberResults["r5s2"]],
            ["rubber6", [thisPlayers["t1p2"], thisPlayers["t1p3"]], [thisPlayers["t2p2"], thisPlayers["t2p3"]], rubberResults["r6s1"], rubberResults["r6s2"]],
        ]
        setrubbers(newrubbers)
    }

    function genRubbersMode2() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], rubberResults["r1s1"], rubberResults["r1s2"]],
            ["rubber2", [thisPlayers["t1p1"]], [thisPlayers["t2p2"]], rubberResults["r2s1"], rubberResults["r2s2"]],

            ["rubber3", [thisPlayers["t1p2"]], [thisPlayers["t2p1"]], rubberResults["r3s1"], rubberResults["r3s2"]],
            ["rubber4", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], rubberResults["r4s1"], rubberResults["r4s2"]],

            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], rubberResults["r5s1"], rubberResults["r5s2"]],
        ]
        setrubbers(newrubbers)
    }

    function genEditRubbers() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], [r1s1, setr1s1], [r1s2, setr1s2]],
            ["rubber2", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], [r2s1, setr2s1], [r2s2, setr2s2]],
            ["rubber3", [thisPlayers["t1p3"]], [thisPlayers["t2p3"]], [r3s1, setr3s1], [r3s2, setr3s2]],
            ["rubber4", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], [r4s1, setr4s1], [r4s2, setr4s2]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p3"]], [thisPlayers["t2p1"], thisPlayers["t2p3"]], [r5s1, setr5s1], [r5s2, setr5s2]],
            ["rubber6", [thisPlayers["t1p2"], thisPlayers["t1p3"]], [thisPlayers["t2p2"], thisPlayers["t2p3"]], [r6s1, setr6s1], [r6s2, setr6s2]],
        ]
        seteditRubbers(newrubbers)
    }

    function genEditRubbersMode2() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], [r1s1, setr1s1], [r1s2, setr1s2]],
            ["rubber2", [thisPlayers["t1p1"]], [thisPlayers["t2p2"]], [r2s1, setr2s1], [r2s2, setr2s2]],
            ["rubber3", [thisPlayers["t1p2"]], [thisPlayers["t2p1"]], [r3s1, setr3s1], [r3s2, setr3s2]],
            ["rubber4", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], [r4s1, setr4s1], [r4s2, setr4s2]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], [r5s1, setr5s1], [r5s2, setr5s2]],
        ]
        seteditRubbers(newrubbers)
    }

    function newRubber(name, t1players, t2players, t1score, t2score) {
        return <Rubber name={name} t1players={t1players} t2players={t2players} t1score={t1score} t2score={t2score} ></Rubber>
    }

    function newEditRubber(name, team1, team2, t1score, sett1score, t2score, sett2score) {
        return <EditRubber name={name} team1={team1} team2={team2} t1score={t1score} sett1score={sett1score} t2score={t2score} sett2score={sett2score} ></EditRubber>
    }

    function initEditRubber() {
        setr1s1(rubberResults["r1s1"] || rubberResults["r1s1"] === 0 ? rubberResults["r1s1"] : null)
        setr2s1(rubberResults["r2s1"] || rubberResults["r2s1"] === 0 ? rubberResults["r2s1"] : null)
        setr3s1(rubberResults["r3s1"] || rubberResults["r3s1"] === 0 ? rubberResults["r3s1"] : null)
        setr4s1(rubberResults["r4s1"] || rubberResults["r4s1"] === 0 ? rubberResults["r4s1"] : null)
        setr5s1(rubberResults["r5s1"] || rubberResults["r5s1"] === 0 ? rubberResults["r5s1"] : null)
        setr6s1(rubberResults["r6s1"] || rubberResults["r6s1"] === 0 ? rubberResults["r6s1"] : null)
        setr1s2(rubberResults["r1s2"] || rubberResults["r1s2"] === 0 ? rubberResults["r1s2"] : null)
        setr2s2(rubberResults["r2s2"] || rubberResults["r2s2"] === 0 ? rubberResults["r2s2"] : null)
        setr3s2(rubberResults["r3s2"] || rubberResults["r3s2"] === 0 ? rubberResults["r3s2"] : null)
        setr4s2(rubberResults["r4s2"] || rubberResults["r4s2"] === 0 ? rubberResults["r4s2"] : null)
        setr5s2(rubberResults["r5s2"] || rubberResults["r5s2"] === 0 ? rubberResults["r5s2"] : null)
        setr6s2(rubberResults["r6s2"] || rubberResults["r6s2"] === 0 ? rubberResults["r6s2"] : null)
    }

    function handleChangeMode(event) {
        let isChecked = event.target.checked
        matchRef.update({
            isMode2: isChecked
        })
            .then(() => {
                console.log("updated isMode2")
                setisMode2(isChecked)
            })
            .catch((e) => { console.log(e) })
    }

    useEffect(() => {
        if (isMode2) { genEditRubbersMode2() }
        else { genEditRubbers() }
    }, [r1s1, r1s2, r2s1, r2s2,
        r3s1, r3s2, r4s1, r4s2,
        r5s1, r5s2, r6s1, r6s2])

    useEffect(() => {
        initEditRubber()
        updatePlyRefs()
        if (isMode2) {
            genRubbersMode2()
            genEditRubbersMode2()
        }
        else {
            genRubbers()
            genEditRubbers()
        }

    }, [thisPlayers, rubberResults])

    useEffect(() => {
        if (isMode2) {
            genRubbersMode2()
            genEditRubbersMode2()
        } else {
            genRubbers()
            genEditRubbers()
        }
    }, [isMode2])

    useEffect(() => {
        getRubResults()
    }, [onEditScore])

    useEffect(() => {
        getthisPlayers()

        getavailablePlys()
        getPlayerPool()

        genRubbers()
        genEditRubbers()
        getRubResults()
    }, [id])


    const displayRubbers = rubbers.map((elem, ind) => {
        let name = elem[0]
        let t1players = elem[1]
        let t2players = elem[2]
        let t1score = elem[3]
        let t2score = elem[4]
        return (
            <div key={ind}>
                {newRubber(name, t1players, t2players, t1score, t2score)}
            </div>
        )
    })

    const displayEditRubbers = editRubbers.map((elem, ind) => {
        let name = elem[0]
        let t1players = elem[1] // [player]
        let t2players = elem[2]
        let [t1score, sett1score] = elem[3] // [score, setScore]
        let [t2score, sett2score] = elem[4]

        return (
            <div key={ind}>
                {newEditRubber(name, t1players, t2players, t1score, sett1score, t2score, sett2score)}
            </div>
        )
    })

    const displaythisPlayers = Object.keys(thisPlayers).map((key) => {
        if (thisPlayers[key]) {
            return (
                <tr>
                    <td>{key}</td>
                    <td>{thisPlayers[key] ? thisPlayers[key].player.displayName : "null"}</td>
                </tr>
            )
        }
    })

    const displayMode3 = Object.entries(inputPlayerRefs).map((pRef) => {
        return (
            <Autocomplete
                value={inputPlayerRefs[pRef[0]].value}
                onChange={(event, newVal) => {
                    inputPlayerRefs[pRef[0]].setFunc(newVal)
                }}
                options={chooseFromAllPlys === "true" ? playerPool : availablePlys}
                getOptionLabel={(option) => option.player.displayName}
                style={{ width: 300, margin: "auto", marginTop: "5px" }}
                renderInput={(params) => <TextField {...params} label={inputPlayerRefs[pRef[0]].name} variant="outlined" />}
            />
        )
    }
    )

    const displayMode2 = Object.entries(inputPlayerRefsMode2).map((pRef) => {
        return (
            <Autocomplete
                value={inputPlayerRefsMode2[pRef[0]].value}
                onChange={(event, newVal) => {
                    inputPlayerRefsMode2[pRef[0]].setFunc(newVal)
                }}
                options={chooseFromAllPlys === "true" ? playerPool : availablePlys}
                getOptionLabel={(option) => option.player.displayName}
                style={{ width: 300, margin: "auto", marginTop: "5px" }}
                renderInput={(params) => <TextField {...params} label={inputPlayerRefsMode2[pRef[0]].name} variant="outlined" />}
            />
        )
    }
    )

    const displayAddthisPlayers = (
        <div>
            <Card className="player-table-container">
                <Card.Title>
                    Add players to this match
                </Card.Title>
                <Card.Body>
                    <FormGroup column>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Choose from:</FormLabel>
                            <RadioGroup aria-label="gender" name="gender1" value={chooseFromAllPlys} onChange={(event => {
                                setchooseFromAllPlys(event.target.value)
                            })}>
                                <FormControlLabel value="false" control={<Radio />} label="Only players available" />
                                <FormControlLabel value="true" control={<Radio />} label="All players" />
                            </RadioGroup>
                        </FormControl>
                    </FormGroup>



                    {isMode2 ? displayMode2 : displayMode3}

                    <Button variant="light" onClick={handleCancelAddPlayers}>Cancel</Button>
                    <Button onClick={handleConfAddPlayers}>Save</Button>
                </Card.Body>
            </Card>
        </div>
    )

    const displayEditMatch = (
        <div>
            <Card>
                <Card.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={matchName}
                                placeholder="give this match a name"
                                onChange={(event) => { setmatchName(event.target.value) }}
                            ></Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={matchTime}
                                onChange={(event) => { setmatchTime(event.target.value) }}
                            ></Form.Control>
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>

            <Button variant="light" onClick={() => { setonEditMatch(false) }}>Cancel</Button>
            <Button onClick={handleConfEditMatch}>Save</Button>
        </div>
    )

    const displayMatch = (
        <div id="match-container">
            <div>
                {/* {onEditMatch? 
                    displayEditMatch
                    :
                    <Button variant="link" onClick={() => {setonEditMatch(true)}}>Edit match info</Button>    
                } */}


                <Card className="toggle-button">
                    <Card.Body>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <SwitchBut
                                        checked={isMode2}
                                        onChange={handleChangeMode}
                                        color="primary"
                                    />
                                }
                                label={isMode2 ? "Teams of 2" : "Teams of 3"}
                            />
                        </FormGroup>
                    </Card.Body>
                </Card>


                {thisPlayers == null ? <div>No players has been added</div>
                    :
                    <div className="center scoreboard-container">
                        <Card className="center scoreboard">
                            <Card.Body>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Position</th>
                                            <th>Player name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displaythisPlayers}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>

                    </div>
                }

                {onAdd ? displayAddthisPlayers : <Button onClick={handleAddthisPlayers}>+ add thisPlayers</Button>
                }

                {onEditScore ?
                    <div className="center scoreboard-container">
                        {displayEditRubbers}
                        <Button variant="outline-secondary" onClick={() => { setonEditScore(false) }}>Cancel</Button>
                        <Button variant="danger" onClick={handleConfSaveRst}>Save</Button>
                    </div>
                    :
                    <div className="center padding scoreboard-container">
                        {displayRubbers}
                        <Button variant="primary" onClick={() => { setonEditScore(true) }}>Edit Score</Button>
                    </div>
                }
            </div>

            {onDel ?
                <div>
                    <span>Do you want to delete this Match?</span>
                    <Button variant="outline-secondary" onClick={handleCancel}>Cancel</Button>
                    <Button variant="danger" onClick={handleConfDel}>Delete</Button>
                </div>
                : <Button variant="danger" onClick={handleDelete}>Delete this Match</Button>}
        </div>
    )

    return (
        <div>
            {loading ? <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
            </Spinner> : displayMatch}
        </div>
    )

}